import { StyleSheet, View, ViewProps } from 'react-native'
import { Color, Icon } from 'zens-storybook'

const styles = StyleSheet.create({
  container: {
    width: 20,
    height: 20,
    borderRadius: 10,
    borderColor: Color.refinedGreen,
    borderWidth: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
})

interface Props extends ViewProps {}

const Success = (props: Props) => {
  const { style, ...otherProps } = props

  return (
    <View style={[styles.container, style]} {...otherProps}>
      <Icon name="checkmark" color={Color.refinedGreen} size="S" />
    </View>
  )
}

export default Success
